import { clsx } from 'clsx';
import { Typography } from '@material-ui/core';
import { ErrorOutline, ReportProblemOutlined } from '@material-ui/icons';

// TODO: separate styles to a separate file for each component
import OrderMgmtStyle from '../../../OrderManagement.style';

export function ChipOrderDisclaimer(props: Props) {
  const {
    disclaimer,
    type,
    hasIcon = false,
    classes = {
      disclaimer: '',
      icon: '',
      text: '',
    },
  } = props;

  const _classes = OrderMgmtStyle({ type });

  const getIcon = () => {
    if (type === 'danger')
      return (
        <ReportProblemOutlined
          className={clsx(classes.icon, _classes.chipOrderIcon)}
        />
      );
    return (
      <ErrorOutline className={clsx(classes.icon, _classes.chipOrderIcon)} />
    );
  };

  return (
    <div
      role='alert'
      className={clsx(classes.disclaimer, _classes.chipOrderDisclaimer)}
    >
      {hasIcon && getIcon()}
      <Typography
        className={clsx(classes.text, _classes.chipOrderText)}
        dangerouslySetInnerHTML={{
          __html: disclaimer || '',
        }}
      />
    </div>
  );
}

interface Props {
  disclaimer?: string;
  hasIcon?: boolean;
  type?: any;
  classes?: {
    disclaimer?: string;
    icon?: string;
    text?: string;
  };
}
